import React from 'react';
import { Field, ErrorMessage } from 'formik';

import { StyledTableDataContents, StyledTableDataLabel } from './styled';

type SharingCodeInputRowProps = {
  inputName: string;
};

const SharingCodeInputRow: React.FC<SharingCodeInputRowProps> = ({
  inputName,
}) => (
    <tr>
      <StyledTableDataLabel textAlignTop>
        <label>Sharing Code: </label>
      </StyledTableDataLabel>
      <StyledTableDataContents flexCol>
        <Field
          autoComplete="off"
          type="text"
          className="form-control"
          name={inputName}
        />
        <ErrorMessage name={inputName} component="label" className="error" />
      </StyledTableDataContents>
    </tr>
  );

export default SharingCodeInputRow;
